import $ from "../jquery_global";

window.AdminQuotations = {
  handleSearchAndFilter: () => {
    $(document).ready(function() {
      function formatDate(date) {
        var year = date.getFullYear();
        var month = ("0" + (date.getMonth() + 1)).slice(-2);
        var day = ("0" + date.getDate()).slice(-2);
        var dateString = [year, month, day].join("-");
        return dateString;
      }

      var dateFrom = '#{params["date_from"]}';
      var dateTo = '#{params["date_to"]} ';

      var dateFlatpickr = $("#datePicker")[0]._flatpickr;
      dateFlatpickr.config.onChange.push(function(selectedDates, dateStr, instance) {
        if (selectedDates.length > 0) {
          var fromDate = selectedDates[0];
          $("#date_from").val(formatDate(fromDate));
        }
        if (selectedDates.length > 1) {
          var toDate = selectedDates[1];
          $("#date_to").val(formatDate(toDate));
        }
      });
    });

  }
}
